/* import React from 'react';

import * as st from './oldStyles.module.scss';

type Props = {
	children?: React.ReactNode | React.ReactNodeArray;
};

const Container: React.FC<Props> = ({ children }) => {
	return <div className={st.container}>{children}</div>;
};

export default Container;
 */

import type React from 'react';
import * as st from './styles.module.scss';
import cn from 'classnames';

type Props = {
	children?: React.ReactNode | React.ReactNodeArray;
	style?: React.CSSProperties;
	className?: string
};

const Container: React.FC<Props> = ({ children, style, className }) => {
	return <div className={cn(st.container, className)} style={style}>{children}</div>;
};

export default Container;